import { CarCategory, FuelType, TransmissionType } from '@workspace/database';

// Romanian labels for car categories
export const carCategoryLabel: Record<CarCategory, string> = {
  [CarCategory.PLATINUM]: 'Executive',
  [CarCategory.GOLD]: 'Luxury',
  [CarCategory.SILVER]: 'Standard'
};

// Romanian labels for fuel types
export const fuelTypeLabel: Record<FuelType, string> = {
  [FuelType.PETROL]: 'Benzină',
  [FuelType.DIESEL]: 'Diesel',
  [FuelType.HYBRID]: 'Hibrid',
  [FuelType.ELECTRIC]: 'Electric'
};

// Romanian labels for transmission types
export const transmissionTypeLabel: Record<TransmissionType, string> = {
  [TransmissionType.AUTOMATIC]: 'Automată',
  [TransmissionType.MANUAL]: 'Manuală'
};

// Get category display name for URLs
export function getCategoryDisplayName(category: string): string {
  switch (category.toLowerCase()) {
    case 'platinum':
      return 'Executive';
    case 'gold':
      return 'Luxury';
    case 'silver':
      return 'Standard';
    default:
      return 'Toate';
  }
}
